/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_React as React,
  rec_Xi as Xi,
  rec_Yr as Yr,
  rec_Za as Za,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ImagenMarca({
  def: e,
  url: t,
  onCambio: n,
  avisos: r,
  confirmar: i,
}) {
  let a = (0, React.useRef)(null),
    [o, s] = (0, React.useState)(!1);
  async function c(t) {
    let i = t.target.files?.[0];
    if (((t.target.value = ``), i)) {
      s(!0);
      try {
        let t = new FormData();
        (t.append(`archivo`, i),
          await Za(`/config/marca/archivo/${e.id}`, t),
          await n(),
          r.ok(`${e.label}: listo`));
      } catch (e) {
        r.error(e.message);
      } finally {
        s(!1);
      }
    }
  }
  async function l() {
    if (
      await i({
        titulo: `Quitar ${e.label.toLowerCase()}`,
        mensaje: `Vuelve la imagen que trae la aplicación.`,
        confirmarTexto: `Quitar`,
        peligro: !0,
      })
    )
      try {
        (await api(`/config/marca/archivo/${e.id}`, {
          method: `DELETE`,
        }),
          await n(),
          r.ok(`Quitado`));
      } catch (e) {
        r.error(e.message);
      }
  }
  return (
    <li
      className={`flex items-center gap-3 rounded-2xl border border-(--border) p-2.5`}
      children={[
        <span
          className={`flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-(--panel)`}
          children={
            t ? (
              <img
                src={t}
                alt={``}
                className={`max-h-9 max-w-9 object-contain`}
              />
            ) : (
              <Yr className={`h-4 w-4 text-(--text)`} />
            )
          }
        />,
        <div
          className={`min-w-0 flex-1`}
          children={[
            <p className={`text-sm text-(--text-h)`} children={e.label} />,
            <p
              className={`text-xs text-(--text)`}
              children={t ? `Cargado` : e.ayuda}
            />,
          ]}
        />,
        <input
          ref={a}
          type={`file`}
          className={`hidden`}
          accept={`image/png,image/jpeg,image/webp,image/svg+xml`}
          onChange={c}
        />,
        <AccionAsync
          variante={`chico`}
          icono={Xi}
          ocupado={o}
          onClick={() => a.current?.click()}
          children={t ? `Cambiar` : `Subir`}
        />,
        t && (
          <button
            type={`button`}
            onClick={l}
            aria-label={`Quitar ${e.label}`}
            className={`${zo} !px-2.5 !py-2.5`}
            children={<Ki className={`h-4 w-4`} />}
          />
        ),
      ]}
    />
  );
}
